/* Suprimal "How to use" ritual on product pages: an animated scene per step, a clock that follows the product's time of day,
   auto-advance while on screen (pauses on hover, focus, tap or the pause button, never runs with reduced motion). */
(function () {
  'use strict';
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var DWELL = { peel: 3600, dissolve: 4050, night: 3900, breathe: 5250, water: 3900, loop: 4200, move: 3750, meal: 3750, tin: 3150 };
  function reduced() { return !!(RM && RM.matches); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function near(from, to) { return from + (((to - from) % 360) + 540) % 360 - 180; }

  function init(root) {
    if (!root || root.__rit) return;
    root.__rit = 1;
    var steps = [].slice.call(root.querySelectorAll('[data-rit-step]'));
    var n = steps.length;
    if (!n) return;
    var scenes = [].slice.call(root.querySelectorAll('[data-rit-scene]'));
    var segs = [].slice.call(root.querySelectorAll('[data-rit-seg]'));
    var list = root.querySelector('.sp-rit__steps');
    var stage = root.querySelector('[data-rit-stage]');
    var num = root.querySelector('[data-rit-num]');
    var capn = root.querySelector('[data-rit-capn]');
    var cap = root.querySelector('[data-rit-cap]');
    var tlabel = root.querySelector('[data-rit-time]');
    var clock = root.querySelector('[data-rit-clock]');
    var hh = clock && clock.querySelector('.h');
    var mh = clock && clock.querySelector('.m');
    var tgl = root.querySelector('[data-rit-toggle]');
    var auto = root.getAttribute('data-autoplay') !== 'false';
    var cur = -1, t = 0, last = 0, raf = 0;
    var inView = false, live = false, hover = false, focus = false, held = false, stopped = false;
    var aH = 0, aM = 0;

    function dwell(i) { return DWELL[steps[i].getAttribute('data-scene')] || 3600; }
    function setP(p) {
      var v = p.toFixed(4);
      if (segs[cur]) segs[cur].style.setProperty('--p', v);
      steps[cur].style.setProperty('--p', v);
    }
    function swap(el, txt) {
      if (!el || txt == null || el.textContent === txt) return;
      el.classList.remove('is-swap');
      void el.offsetWidth;
      el.textContent = txt;
      el.classList.add('is-swap');
    }
    function setClock(v) {
      if (!clock) return;
      var spin = v === 'loop';
      clock.classList.toggle('is-spin', spin);
      var m = /^(\d{1,2}):(\d{2})$/.exec(v || '');
      if (!m) return;
      var hr = +m[1], mi = +m[2];
      aM = near(aM, mi * 6);
      aH = near(aH, (hr % 12) * 30 + mi / 2);
      mh.style.setProperty('--a', aM + 'deg');
      hh.style.setProperty('--a', aH + 'deg');
    }
    function play(sc) {
      sc.classList.remove('is-play');
      void sc.getBoundingClientRect();
      sc.classList.add('is-play');
    }
    function go(i, replay) {
      if (i === cur && !replay) return;
      cur = i; t = 0;
      steps.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        s.classList.toggle('is-done', k < i);
        s.style.setProperty('--p', k < i ? '1' : '0');
        var b = s.querySelector('button');
        if (b) b.setAttribute('aria-current', k === i ? 'step' : 'false');
      });
      segs.forEach(function (s, k) {
        s.style.setProperty('--p', k < i ? '1' : '0');
        s.classList.toggle('is-active', k === i);
      });
      scenes.forEach(function (sc, k) {
        clearTimeout(sc.__t);
        if (k === i) {
          sc.classList.add('is-active');
          if (live) play(sc);
        } else if (sc.classList.contains('is-active')) {
          sc.classList.remove('is-active');
          sc.__t = setTimeout(function () { sc.classList.remove('is-play'); }, 650);
        } else {
          sc.classList.remove('is-play');
        }
      });
      var s = steps[i];
      if (stage) stage.setAttribute('data-light', s.getAttribute('data-light') || 'day');
      if (num) num.textContent = pad(i + 1);
      if (capn) capn.textContent = pad(i + 1);
      swap(cap, s.getAttribute('data-title'));
      swap(tlabel, s.getAttribute('data-hud'));
      setClock(s.getAttribute('data-clock'));
      if (list) list.style.setProperty('--rail', n > 1 ? (i / (n - 1)).toFixed(4) : '1');
    }

    function playing() { return auto && !stopped && !held && inView && !hover && !focus && !document.hidden && !reduced(); }
    function frame(ts) {
      raf = 0;
      if (!playing()) { last = 0; return; }
      var dt = last ? Math.min(ts - last, 80) : 0;
      last = ts;
      t += dt;
      var p = t / dwell(cur);
      if (p >= 1) go((cur + 1) % n);
      else setP(p);
      raf = requestAnimationFrame(frame);
    }
    function kick() {
      syncToggle();
      if (!raf && playing()) { last = 0; raf = requestAnimationFrame(frame); }
    }
    function syncToggle() {
      if (!tgl) return;
      var canPlay = auto && !reduced();
      tgl.hidden = !canPlay;
      var paused = stopped || held;
      tgl.setAttribute('aria-pressed', paused ? 'true' : 'false');
      tgl.setAttribute('aria-label', paused ? 'Play the steps' : 'Pause the steps');
    }

    steps.forEach(function (s, k) {
      var b = s.querySelector('button');
      if (!b) return;
      b.addEventListener('click', function () {
        held = true;
        go(k, true);
        setP(0);
        kick();
      });
      b.addEventListener('keydown', function (e) {
        var to = -1;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') to = (k + 1) % n;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') to = (k - 1 + n) % n;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = n - 1;
        if (to < 0) return;
        e.preventDefault();
        var nb = steps[to].querySelector('button');
        if (nb) nb.focus();
        held = true;
        go(to, true);
        kick();
      });
    });
    segs.forEach(function (s, k) {
      s.addEventListener('click', function () { held = true; go(k, true); kick(); });
    });
    if (stage) {
      stage.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-rit-toggle]')) return;
        held = true;
        go(cur, true);
        kick();
      });
    }
    if (tgl) {
      tgl.addEventListener('click', function (e) {
        e.stopPropagation();
        if (stopped || held) { stopped = false; held = false; }
        else stopped = true;
        kick();
      });
    }
    var side = root.querySelector('.sp-rit__side') || root;
    side.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; kick(); } });
    side.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; kick(); } });
    root.addEventListener('focusin', function (e) {
      var kb = false;
      try { kb = e.target.matches(':focus-visible'); } catch (err) { kb = false; }
      if (kb) { focus = true; kick(); }
    });
    root.addEventListener('focusout', function () { setTimeout(function () { if (!root.contains(document.activeElement)) { focus = false; kick(); } }, 0); });
    document.addEventListener('visibilitychange', kick);
    if (RM && RM.addEventListener) RM.addEventListener('change', kick);

    var cta = root.querySelector('[data-rit-cta]');
    if (cta) {
      cta.addEventListener('click', function (e) {
        var form = document.querySelector('[data-sp-buybox]');
        if (!form) return;
        e.preventDefault();
        var head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72;
        var y = form.getBoundingClientRect().top + window.pageYOffset - head - 24;
        window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' });
        form.classList.remove('sp-rit-flash');
        setTimeout(function () {
          form.style.setProperty('--rt-glow', getComputedStyle(root).getPropertyValue('--rt-glow'));
          form.classList.add('sp-rit-flash');
          setTimeout(function () { form.classList.remove('sp-rit-flash'); }, 1700);
        }, reduced() ? 0 : 650);
      });
    }

    go(0, true);
    syncToggle();

    function enter() {
      inView = true;
      root.classList.add('is-inview');
      if (!live) {
        live = true;
        root.classList.add('is-live');
        if (scenes[cur]) play(scenes[cur]);
      }
      if (!stopped) held = false;
      kick();
    }
    function leave() {
      inView = false;
      root.classList.remove('is-inview');
      kick();
    }
    if ('IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting && x.intersectionRatio >= 0.3) { if (!inView) enter(); }
          else if (inView) leave();
        });
      }, { threshold: [0, 0.3] }).observe(stage || root);
    } else {
      enter();
    }

    root.__ritGo = function (i) { held = true; go(i, true); kick(); };
  }

  function boot(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-sp-rit]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var li = e.target && e.target.closest && e.target.closest('[data-rit-step]');
    if (!li) return;
    var root = li.closest('[data-sp-rit]');
    if (!root || !root.__ritGo) return;
    var all = [].slice.call(root.querySelectorAll('[data-rit-step]'));
    root.__ritGo(all.indexOf(li));
  });
})();